// src/styles/GlobalStyle.ts
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* RESET CSS */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  main, menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  article, aside, details, figcaption, figure, 
  footer, header, hgroup, main, menu, nav, section {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote::before,
  blockquote::after,
  q::before,
  q::after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  colgroup {
    display: table-column-group;
  }

  col {
    display: table-column;
    unicode-bid: isolate;
  }

  thead {
    display: table-header-group;
    vertical-align: middle;
    border-color: #e5e5e5;
  }

  tr {
    display: table-row;
    vertical-align: inherit;
    border-color: #e5e5e5;
  }

  tbody {
    display: table-row-group;
    vertical-align: middle;
  }

  /* GLOBAL CSS */
  :root {
    --main-bg: white;
    --main-color: #444444;
    --accent-color: #A0C4FF;
    --border-radius: 6px;
    --transition: 0.2s;
    --hover-color: #777;
    --error-color: #FC5858;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background-color: var(--main-bg);
    color: var(--main-color);
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    overflow-y: scroll;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul, ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  img {
    max-width: 100%;
    display: block;
  }

  button {
    font-family: inherit;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
  }

  input, textarea {
    font-family: inherit;
    outline: none;
    border: 0;
    padding: 0;
    background: none;
    box-sizing: border-box;
    box-shadow: none;
    margin: 0;
  }

`;

export default GlobalStyle;
